import React, { useEffect } from "react";
import Page from "../components/Page";
import GameCanvas from "../components/GameCanvas";

const Showcase: React.FC = () => {
  // Hint PreloadScene which scene to jump to *before* Phaser bootstraps
  if (typeof window !== "undefined") {
    (window as any).__targetScene = "CatShowcaseScene";
  }

  useEffect(() => {
    const game: any = (window as any).PhaserGame;
    if (!game) return;

    // Tell PreloadScene which scene to start after loading
    game.registry.set("targetScene", "CatShowcaseScene");

    // Stop budgeting scene if it is currently running
    if (game.scene.isActive("BudgetSceneReact")) {
      game.scene.stop("BudgetSceneReact");
    }

    // Start showcase scene (if not already active)
    if (!game.scene.isActive("CatShowcaseScene")) {
      game.scene.start("CatShowcaseScene");
    }

    return () => {
      // When leaving the Showcase page, stop the showcase scene so other
      // pages (e.g.
      // budget) can start fresh without multiple scenes piling up.
      if (game.scene.isActive("CatShowcaseScene")) {
        game.scene.stop("CatShowcaseScene");
      }
    };
  }, []);

  return (
    <Page title="Cat Showcase">
      {/* Re-use the shared Phaser canvas */}
      <GameCanvas levelId="showcase" />
    </Page>
  );
};

export default Showcase;
